<script>
import {defineComponent, onBeforeMount, ref} from "vue";
import MainCard from "@/components/cards/MainCard.vue";
import InputText from "primevue/inputtext";

import {useApiCall} from "@/composables/useApiCall";
import {
  getServiceLinkApiCall,
  updateServiceLinkApiCall,
} from "@/services/settings";
import Skeleton from "primevue/skeleton";
import Button from "primevue/button";

export default defineComponent({
  components: {
    Button,
    Skeleton,
    MainCard,
    InputText
  },
  setup() {
    const linkText = ref('')
    const errors = ref(null)
    const {
      isLoading: isLinkLoading,
      data: linkData,
      error: linkError,
      executeApiCall: getLinkAction,
    } = useApiCall(getServiceLinkApiCall, true)

    const {
      isLoading: isUpdateLinkLoading,
      error: updateLinkError,
      executeApiCall: updateLinkAction,
    } = useApiCall(updateServiceLinkApiCall, true)

    const update = async () => {
      errors.value = null
      try {
        await updateLinkAction({link: linkText.value})
      } catch {
        if (updateLinkError.value.data.link) {
          errors.value = updateLinkError.value.data.link.join(', ')
        }
      }
    }
    onBeforeMount(async () => {
      try {
        await getLinkAction()
        if (linkData.value?.data) {
          linkText.value = linkData.value.data.link
        }
      } catch {
        console.error(linkError.value)
      }
    })

    return {
      isLinkLoading,
      update,
      isUpdateLinkLoading,
      errors,
      linkText,
    };
  }
})
</script>

<template>
  <section class="stub">
    <Skeleton v-if="isLinkLoading" height="187px"></Skeleton>
    <template v-else>
      <Button
          @click="update"
          :loading="isUpdateLinkLoading"
          label="Сохранить изменения"
          class="btn-primary btn-fix-height font-light ml-3 stub__save"
      />
      <MainCard title="Ссылка на услуги" style="max-width: 50%">
            <span class="p-float-label w-full">
              <InputText
                  :class="{'p-invalid': errors }"
                  id="name_ru"
                  class="w-full"
                  v-model="linkText"
              />
              <label for="name_ru">Введите ссылку <i style="color: #E26B6B">*</i></label>
            </span>
        <span v-if="errors"
              class="color-error mt-3">{{ errors }}</span>
      </MainCard>
    </template>
  </section>
</template>

<style lang="css" scoped>
.stub {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.stub__save {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 2;
}
</style>